import { ProductsGrid } from "@features/products/components/ProductsGrid";

import { ProductRecord } from "@features/products/store";
import { paths } from "@features/routering/paths";
import { InfiniteLoadSection } from "@features/sections/components/InfiniteLoadSection";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import React, { FC, memo, useCallback } from "react";

export interface SeasonalProductsSectionProps {
  className?: string;
  style?: React.CSSProperties;
  data?: ProductRecord[];

  isLoading: boolean;
  isFetching: boolean;
}

const _SeasonalProductsSection: FC<SeasonalProductsSectionProps> = (props) => {
  const { isLoading, data, isFetching, ...restProps } = props;

  const router = useRouter();

  const showMoreHandler = useCallback(() => {
    router.push(paths.seasonalProducts());
  }, [router]);

  const t = useTranslations("SectionTitles");
  const h = useTranslations("SectionExtras");

  return (
    <InfiniteLoadSection
      title={t("SeasonalProducts.title")}
      showMoreText={h("OnShowMore.title")}
      onShowMore={showMoreHandler}
      {...restProps}
    >
      <ProductsGrid data={data} isLoading={isLoading} isFetching={isFetching} />
    </InfiniteLoadSection>
  );
};

export const SeasonalProductsSection = memo(_SeasonalProductsSection);
